export default {
    "versionExplainer": {
        "toggle": "VX oder Elite? Welche Version passt zu mir?",
        "note": "Das sind zwei getrennte, eigenständige Versionen. Ein VX-Freischaltcode schaltet NICHT die Elite-Version frei – und umgekehrt.",
        "vx": {
            "tag": "Alle Geräte",
            "title": "VX-Version",
            "point1": "Läuft auf allen unterstützten Uhren",
            "point2": "Kostenlose Testphase, danach Freischaltung per gekauftem Code",
            "point3": "Der Code ist an ein Gerät gebunden"
        },
        "elite": {
            "tag": "Garmin Pay",
            "title": "Elite-Version",
            "point1": "Einmalkauf über Garmin Pay",
            "point2": "An dein Garmin-Konto gebunden, nicht an ein einzelnes Gerät",
            "point3": "Nur auf Uhren, die Garmin Pay unterstützen"
        }
    },
    "navigation": {
        "allWatchfaces": "Alle Apps",
        "faq": "FAQ",
        "helpCenter": "Hilfe & Anleitungen",
        "newsletter": "Newsletter",
        "contact": "Kontakt",
        "weatherProvider": "Wetter Provider",
        "tides": "Gezeiten",
        "colors": "Farben",
        "fonts": "Schriftarten"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Moderne Garmin Apps mit erweiterten Funktionen für alle deine Aktivitäten",
        "features": {
            "tides": "🌊 Gezeiten",
            "weather": "🌤️ Wetter",
            "themes": "🎨 Farbthemes",
            "gps": "📍 GPS"
        },
        "availableWatchfaces": "Verfügbare Watchfaces",
        "newBadge": "Neu",
        "loading": "Watchfaces werden geladen...",
        "error": "Fehler beim Laden",
        "retry": "Erneut versuchen",
        "filter": {
            "label": "Produktfilter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "Alle",
            "noProducts": "Keine Produkte in dieser Kategorie"
        }
    },
    "watchface": {
        "purchase": "Jetzt kaufen",
        "buy": "Kaufen",
        "features": "Funktionen",
        "colorThemes": "Farbthemes",
        "themeDescription": "Klicke auf ein Theme, um den Theme-String zu kopieren und in deinen Watchface-Einstellungen zu verwenden.",
        "dynamicThemeSwitching": "Dynamisches Theme-Switching",
        "sunsetSwitching": {
            "title": "🌅 Nach Sonnenuntergang / Vor Sonnenaufgang",
            "description": "Setze ein Ausrufezeichen ! vor den Theme-String, um automatisch nach Sonnenuntergang zu wechseln (Beispiel: !UEUE[UEUEEEEEEU^)."
        },
        "lowPowerSwitching": {
            "title": "🔋 Im Energiesparmodus",
            "description": "Setze ein Rautenzeichen # vor den Theme-String für den Energiesparmodus (Beispiel: #UEUE[UEUEEEEEEU^)."
        },
        "themeCopied": "Theme-String in die Zwischenablage kopiert!",
        "viewDetails": "Details anzeigen"
    },
    "faq": {
        "title": "Häufig gestellte Fragen",
        "subtitle": "Finden Sie Antworten auf häufige Fragen zu unseren Watchfaces",
        "tabs": {
            "search": "Suche",
            "categories": "Kategorien",
            "all": "Alle FAQs anzeigen"
        },
        "category": {
            "selected": "Ausgewählte Kategorie",
            "showing": "Zeige",
            "items": "Einträge",
            "from": "aus",
            "clear": "Auswahl löschen",
            "back": "Zurück zu Kategorien"
        },
        "viewAnswer": "Antwort ansehen",
        "closeAnswer": "Antwort schließen",
        "darkMode": {
            "enable": "Dark Mode aktivieren",
            "disable": "Dark Mode deaktivieren",
            "light": "Hell",
            "dark": "Dunkel"
        },
        "search": {
            "placeholder": "Nach Hilfe suchen...",
            "button": "Suchen",
            "suggestions": "Beliebte Suchbegriffe",
            "tips": {
                "title": "Suchtipps",
                "keywords": "Verwenden Sie spezifische Schlüsselwörter wie \"GPS\", \"Wetter\" oder \"Einstellungen\"",
                "language": "Die Suche funktioniert in Ihrer gewählten Sprache",
                "categories": "Durchsuchen Sie Kategorien für organisierte Hilfe"
            }
        },
        "noResults": {
            "title": "Keine Ergebnisse gefunden",
            "description": "Versuchen Sie andere Schlüsselwörter oder durchsuchen Sie Kategorien",
            "browseCategories": "Kategorien durchsuchen"
        },
        "suggestions": {
            "title": "Beliebte Suchbegriffe"
        },
        "trending": {
            "title": "Trending Suchbegriffe"
        },
        "categories": {
            "title": "Nach Kategorie durchsuchen",
            "items": "Einträge",
            "allItems": "Alle FAQ-Einträge",
            "allItemsDescription": "Durchsuchen Sie alle häufig gestellten Fragen",
            "noItems": {
                "title": "Keine Einträge in dieser Kategorie",
                "description": "Versuchen Sie, eine andere Kategorie auszuwählen"
            },
            "viewMore": "Alle Einträge anzeigen"
        },
        "results": {
            "title": "Suchergebnisse",
            "found": "Ergebnisse gefunden für",
            "total": "Gesamtergebnisse",
            "bestMatch": "Beste Übereinstimmung",
            "categories": "Kategorien",
            "sortBy": "Sortieren nach",
            "sort": {
                "relevance": "Relevanz",
                "priority": "Priorität",
                "category": "Kategorie"
            },
            "lastUpdated": "Zuletzt aktualisiert",
            "matchedIn": "Gefunden in",
            "footer": "Haben Sie nicht gefunden, wonach Sie gesucht haben?",
            "browseCategories": "Kategorien durchsuchen",
            "viewTrending": "Trending anzeigen",
            "contactSupport": "Support kontaktieren"
        },
        "actions": {
            "copy": "Kopieren",
            "share": "Teilen",
            "copyAnswer": "Antwort kopieren",
            "copyAll": "Alles kopieren"
        },
        "loading": "FAQs werden geladen...",
        "error": "Fehler beim Laden",
        "retry": "Erneut versuchen",
        "questions": {
            "gpsFix": {
                "question": "Was ist ein GPS-Fix und wie kann ich ihn durchführen? / Warum zeigen einige Optionen 'GPS?'",
                "answer": "Ein GPS-Fix ist erforderlich, damit das Watchface weiß, wo Sie sich befinden, um alles bezüglich Sonnen- und Mondzeiten korrekt zu berechnen.\n\nEin GPS-Fix kann durchgeführt werden, indem Sie eine Aktivität starten und warten, bis die Uhr das GPS-Signal erhalten hat, oder durch langes Drücken der GPS-Taste und Warten, bis die Uhr das GPS-Signal erhalten hat.\n\nDanach können Sie zum Watchface zurückkehren und alles sollte korrekt angezeigt werden."
            },
            "userData": {
                "question": "Sammeln die Watchfaces Benutzerdaten?",
                "answer": "Alle TitanicTurtle Watchfaces sammeln keine Benutzerdaten und senden sie nicht an andere Orte. Sie zeigen nur Daten an, die von Garmin bereitgestellt werden, oder führen einige Berechnungen basierend darauf durch (wie aktive Kalorien).\n\nIm Allgemeinen sind alle von Garmin an Drittanbieter-Watchfaces bereitgestellten Daten nicht personalisiert - es gibt beispielsweise keinen Namen oder Ähnliches, der ausgelesen werden könnte."
            },
            "permissions": {
                "question": "Warum benötigen die Watchfaces so viele Berechtigungen?",
                "answer": "TitanicTurtle Watchfaces benötigen Berechtigungen, um die große Auswahl an Daten/Funktionen bereitzustellen.\n\nHier ist jede einzelne erklärt:\n\n<b>Im Hintergrund laufen, wenn es nicht aktiv ist</b> - dies ist erforderlich, um Gezeiten-/Wetterdaten von Drittanbietern in Kombination mit der Internetberechtigung zu aktualisieren\n\n<b>Informationen über das Internet senden/empfangen</b> - dies ist erforderlich, um Gezeiten-/Wetterdaten in Kombination mit dem Laufen im Hintergrund zu aktualisieren.\n\n<b>Daten von anderen Apps lesen und anzeigen</b> - Andere Apps müssen explizit Daten bereitstellen, die von Watchfaces gelesen werden können. Dies umfasst Garmins eigene Apps wie Stress oder BodyBattery, die in Echtzeit aktualisiert werden können. Unautorisierte Daten von anderen Apps können nicht gelesen werden.\n\n<b>GPS-Standort</b> - dies ist erforderlich, um Zeiten wie Sonnenaufgang/Sonnenuntergang, Mondaufgang/Monduntergang zu berechnen und den korrekten Wetterstandort zu erhalten\n\n<b>Herzfrequenz-, Barometer-, Temperatur- und Höhenverlauf</b> - Daten, die auf dem Watchface angezeigt werden - nur für Anzeigezwecke.\n\n<b>Ihr Garmin Connect™ Fitness-Profil</b> - Dies ist erforderlich, um Gewicht anzuzeigen, aktive Kalorien zu berechnen und Energiesparoptionen zu den eingestellten Schlafzeiten zu aktivieren.\n\nEs gibt keine persönlichen Daten wie Namen, Adressen oder Ähnliches, die von Watchfaces ausgelesen werden könnten.\n\nLeider können diese Berechtigungen nicht so eingestellt werden, wie Sie das Watchface verwenden, und sind immer erforderlich."
            },
            "proFeatures": {
                "question": "Was bedeutet ♛ und warum zeigen einige Ansichten 'key'?",
                "answer": "♛ markiert die Pro-Features dieses Watchfaces. Um sie nach Ihrer 5-Tage-Testversion freizuschalten, können Sie einen Freischaltungsschlüssel kaufen.\n\n'key?' bedeutet, dass Ihre Testphase abgelaufen ist."
            },
            "temperatureUnits": {
                "question": "Wie ändere ich die Temperatureinheiten?",
                "answer": "Ändern Sie es, indem Sie die Systemeinstellungen Ihrer Uhr eingeben (lange auf die Menütaste drücken): Navigieren Sie zu System -> Format -> Einheiten und ändern Sie es dort"
            },
            "timeFormat": {
                "question": "Wie stelle ich das 12h/24h Format ein?",
                "answer": "Ändern Sie es, indem Sie die Systemeinstellungen Ihrer Uhr eingeben (lange auf die Menütaste drücken): Navigieren Sie zu System -> Format -> Zeitformat und ändern Sie es dort"
            },
            "distanceUnits": {
                "question": "Wie ändere ich die Einheiten für Entfernungen oder Höhen?",
                "answer": "Ändern Sie es, indem Sie die Systemeinstellungen Ihrer Uhr eingeben (lange auf die Menütaste drücken): Navigieren Sie zu System -> Format -> Einheiten und ändern Sie es dort"
            }
        }
    },
    "helpCenter": {
        "title": "Hilfe & Anleitungen",
        "subtitle": "Antworten, Anleitungen und Instruktionen zu deinen Watchfaces",
        "guidesTitle": "Anleitungen",
        "faqTitle": "Häufig gestellte Fragen",
        "allCategories": "Alle",
        "guides": "Anleitungen",
        "faqResults": "FAQ",
        "noResults": "Keine Ergebnisse gefunden",
        "noResultsHint": "Versuche andere Suchbegriffe oder durchstöbere die Kategorien und Anleitungen unten."
    },
    "guides": {
        "backToHelp": "Zurück",
        "purchase": {
            "title": "Kauf & Installation",
            "tabs": {
                "installation": "Installation",
                "versions": "VX / Elite Versionen",
                "troubleshooting": "Troubleshooting"
            },
            "installation": {
                "title": "Watchfaces über die ConnectIQ App installieren",
                "intro": "Watchfaces können über die Garmin ConnectIQ App für Android oder iOS auf der Uhr installiert werden.",
                "step1": "Verbinde die Uhr per Bluetooth mit dem Telefon und öffne die ConnectIQ App auf dem Telefon.",
                "step2": "Navigiere zu der Seite des Watchfaces, das du installieren möchtest.",
                "step3": "Drücke auf den Button \"Installieren\". Das Watchface wird in die Warteschlange zum Herunterladen gesteckt und auf der Uhr installiert.",
                "step4": "Nach der Installation erscheint eine Meldung in der App bzw. auf der Uhr und das Watchface steht auf dem Gerät zur Verfügung.",
                "noteScreen": "Achte darauf, dass der Bildschirm deines Telefons während der Installation nicht ausgeht und die ConnectIQ App nicht geschlossen oder gewechselt wird – gilt auch für Updates.",
                "selectWatchfaceTitle": "Watchface auf der Uhr auswählen",
                "selectWatchfaceIntro": "Wenn das Watchface installiert ist, aber noch nicht angezeigt wird, muss es eventuell im Systemmenü der Uhr ausgewählt werden.",
                "select1": "Den Menüknopf auf der Uhr (bzw. den entsprechenden Knopf bei Touch-Geräten) lange drücken, um in das Systemmenü zu kommen.",
                "select2": "Zum Menüpunkt \"Watch Faces\" oder \"Displaydesigns\" navigieren.",
                "select3": "In der Liste aller installierten Watchfaces mit den Up/Down-Tasten oder dem Touchscreen navigieren.",
                "select4": "Mit dem Knopf rechts oben das gewünschte Watchface bestätigen – es ist dann auf der Uhr aktiv."
            },
            "versions": {
                "title": "VX vs Elite – was ist der Unterschied?",
                "sameFeatures": "Technisch sind beide Versionen identisch und haben denselben Funktionsumfang. Sie unterscheiden sich nur in der Bezahlweise und Aktivierung.",
                "eliteTitle": "Elite Version (Garmin Pay)",
                "elite1": "Eigene Installation des Watchfaces, das direkt über Garmin Pay im ConnectIQ Store gekauft wird.",
                "elite2": "Die Elite Version ist an deinen Garmin Account gebunden. Kaufst du eine neue Uhr, kannst du die Elite Version dort erneut installieren, ohne einen separaten Key.",
                "elite3": "Garmin Pay ist nicht auf allen Uhren verfügbar und nicht in allen Ländern freigeschaltet.",
                "eliteNoKey": "Wichtig: Beim Kauf einer Elite Version über Garmin Pay wird kein Freischaltcode zugeschickt. Die Elite Version ist direkt nach dem Kauf freigeschaltet und benötigt keinen Code.",
                "vxTitle": "VX / Webseiten-Version",
                "vx1": "Mit einer größeren Anzahl an Geräten kompatibel und oft verfügbar, wenn Garmin Pay nicht unterstützt wird.",
                "vx2": "Enthält einen integrierten Testzeitraum von mehreren Tagen.",
                "vx3": "Nach der Testphase kann ein Freischaltcode über diese Webseite gekauft werden, um die VX Version (bzw. Pro-Funktionen) dauerhaft freizuschalten.",
                "vx4": "Der Freischaltcode gilt immer nur für das Gerät bzw. die WatchfaceID, für die er gekauft wurde.",
                "vx5": "Wird deine Uhr von Garmin im Rahmen der Garantie ausgetauscht, kann ein neuer Key generiert werden. Bitte melde dich in diesem Fall über das Kontaktformular."
            },
            "website": {
                "title": "Kauf über die Webseite (VX / normale Versionen)",
                "step1": "Installiere das Watchface zuerst auf der Uhr (siehe Tab Installation). Die WatchfaceID erscheint erst nach der Installation in den Watchface-Einstellungen.",
                "step2": "Öffne die Watchface-Einstellungen (über die ConnectIQ App oder Garmin Express) und kopiere die WatchfaceID aus dem oberen Feld.",
                "step3": "Wähle auf dieser Webseite das entsprechende Watchface aus und gib deine WatchfaceID in das Kaufformular ein.",
                "step4": "Schließe die Zahlung ab. Du erhältst den Freischaltcode per E-Mail und kannst ihn im Key-Feld der Watchface-Einstellungen eingeben.",
                "noteNoAutoInstall": "Achtung: Der Kauf eines Freischaltcodes über die Webseite installiert das Watchface nicht automatisch auf der Uhr. Die oben beschriebenen Installationsschritte müssen manuell durchgeführt werden."
            },
            "troubleshooting": {
                "installationTitle": "Installationsprobleme (Warteschleife / endlose Updates)",
                "installationIntro": "Manchmal schlägt die Installation fehl, das Watchface hängt lange in der Warteschlange oder die ConnectIQ App meldet ständig Updates.",
                "installationCause": "Das hängt in der Regel mit der ConnectIQ App bzw. den Garmin-Diensten zusammen und nicht mit dem Watchface selbst.",
                "installationFix1": "Starte die Uhr und die ConnectIQ App auf dem Telefon neu.",
                "installationFix2": "Versuche die Installation erneut und achte darauf, dass das Display des Telefons nicht ausgeht und die ConnectIQ App währenddessen geöffnet bleibt.",
                "garminPayTitle": "Garmin Pay Kauf bleibt lange auf \"in progress\"",
                "garminPayText": "Wenn ein Garmin Pay Kauf im ConnectIQ Store über längere Zeit auf einem Status wie \"in progress\" hängen bleibt, wird dieser Vorgang komplett von Garmin gesteuert. Als Entwickler habe ich keinen Einfluss auf das Garmin Pay System. Bitte wende dich in diesem Fall an den offiziellen Garmin Support.",
                "noKeyTitle": "Ich habe nach dem Webseiten-Kauf keinen Freischaltcode erhalten",
                "noKey1": "Prüfe zuerst den Spam-Ordner deines E-Mail-Postfachs – Mails mit Keys landen dort häufig.",
                "noKey2": "In vielen Fällen verhindert ein Tippfehler in der E-Mail-Adresse die Zustellung. Wenn du die Mail nicht findest, kontaktiere mich bitte.",
                "noKey3": "und gib die E-Mail-Adresse (und wenn möglich die WatchfaceID) an, die du für die Zahlung verwendet hast.",
                "noKeyElite": "Hinweis: Beim Kauf einer Elite Version direkt über Garmin Pay im ConnectIQ Store wird kein Freischaltcode verschickt. Die Elite Version ist direkt nach dem Kauf freigeschaltet und benötigt keinen Code."
            },
            "contactLink": "Kontaktformular"
        },
        "timezones": {
            "title": "Zeitzonen & UTC-Offset",
            "basicsTitle": "Was sind zweite und dritte Zeitzone?",
            "basicsText": "In vielen Watchfaces kannst du zwei zusätzliche Zeitzonen konfigurieren. Diese werden meist als \"zweite Zeitzone\" und \"dritte Zeitzone\" bezeichnet und in eigenen Feldern auf dem Watchface angezeigt.",
            "offsetTitle": "UTC-Offsets konfigurieren",
            "offsetIntro": "In den Watchface-Einstellungen gibt es in der Regel ein Feld, in dem du die Offsets der zweiten und dritten Zeitzone in Minuten relativ zur UTC-Zeit angibst.",
            "offsetFormat": "Der erste Wert steht für den Offset der zweiten Zeitzone, der zweite Wert für den Offset der dritten Zeitzone. Die Werte werden in Minuten angegeben und mit einem Leerzeichen getrennt. Ein Pluszeichen wird nicht automatisch ergänzt – positive Werte werden ohne + eingegeben.",
            "exampleLabel": "Beispiel:",
            "exampleExplanation": "Hier hätte die zweite Zeitzone einen Offset von −4,5 Stunden (−270 Minuten) und die dritte Zeitzone einen Offset von +2 Stunden (+120 Minuten), jeweils relativ zu UTC.",
            "changeExample": "Möchtest du die zweite Zeitzone z.B. auf +6 Stunden ändern, muss der erste Wert 360 (6 × 60) lauten. Aus dem obigen Beispiel würde dann werden:",
            "advancedTitle": "Erweiterte Optionen (A/B/C-Suffix)",
            "advancedOptionalHint": "Dieser Abschnitt ist optional. Nur relevant, wenn dein Watchface die A/B/C-Format-Suffixe unterstützt.",
            "advancedIntro": "Ob dein Watchface diese Suffixe unterstützt, steht in der Beschreibung über dem Offset-Feld in den Watchface-Einstellungen. Bei Unterstützung findest du dort eine Beschreibung ähnlich wie:",
            "advancedExample": "UTC 2te + 3te Zeitzonenversatz in Minuten (mit Leerzeichen trennen) (Buchstaben hinter den Offsets: A - 12h Format, B - 24h Format, C - militärisches Format, leer - Standard)",
            "advancedNote": "Diese optionalen Buchstaben (A/B/C) steuern bei einigen Watchfaces das Anzeigeformat der jeweiligen Zeitzone. Verwende sie nur, wenn sie in der Beschreibung des jeweiligen Watchfaces erwähnt werden und du ein anderes Zeitformat benötigst. Für die meisten Nutzer reichen die reinen numerischen Offsets ohne Buchstaben aus.",
            "exampleSectionTitle": "Schritt für Schritt: Anwendungsbeispiel für verschiedene Städte und Formate",
            "exampleIntro": "Das folgende Beispiel zeigt, wie du eine zweite Zeitzone (z. B. New York) und eine dritte Zeitzone (z. B. Tokyo) einstellst und optional 12h- oder 24h-Anzeige für jede wählst.",
            "exampleStep1Title": "Schritt 1: UTC-Offset für die 2. Zeitzone",
            "exampleStep1Text": "Lege die Stadt oder Region für die zweite Zeitzone fest. Rechne die Zeitdifferenz zu UTC in Minuten um. Beispiel: New York (EST, UTC−5) → −300 Minuten. Diesen Wert trägst du als ersten Wert im Einstellungsfeld ein.",
            "exampleStep2Title": "Schritt 2: UTC-Offset für die 3. Zeitzone",
            "exampleStep2Text": "Dasselbe für die dritte Zeitzone. Beispiel: Tokyo (JST, UTC+9) → 540 Minuten. Das ist der zweite Wert, durch ein Leerzeichen vom ersten getrennt.",
            "exampleOnlyOffsets": "Unterstützt dein Watchface keine A/B/C-Suffixe, bist du fertig. Eingabe:",
            "exampleStep3Title": "Schritt 3: Optionales Format-Suffix (A/B/C)",
            "exampleStep3Optional": "Dieser Schritt ist optional: Du kannst die Suffixe weglassen, auch wenn das Watchface sie unterstützt – dann gilt das Standardformat. Willst du 12h-, 24h- oder militärisches Format pro Zeitzone erzwingen, setze den Buchstaben direkt hinter den Offset – kein Leerzeichen zwischen Offset und Suffix.",
            "exampleStep3Text": "Beispiel: 12-Stunden-Format für New York (A) und 24-Stunden für Tokyo (B):",
            "exampleStep3Note": "Kein Suffix bedeutet die Watchface-Standardanzeige (oft 24h). Ob Suffixe unterstützt werden, steht in der Beschreibung über dem Offset-Feld in den Watchface-Einstellungen.",
            "exampleFormatTitle": "So wird die Zeit mit A, B, C angezeigt",
            "exampleFormatIntro": "Für denselben Zeitpunkt unterscheidet sich die Anzeige je Format (Beispiel: 2. Zeitzone New York -300, 3. Zeitzone Tokyo 540). Live-Vorschau:",
            "zone2": "2. Zeitzone",
            "zone3": "3. Zeitzone",
            "exampleTableTitle": "Referenz: UTC-Offsets für ausgewählte Städte (in Minuten)",
            "exampleTableIntro": "Normalzeit; Sommerzeit kann abweichen. Stunden mit 60 multiplizieren."
        },
        "switchViews": {
            "title": "Switchviews & Gestensteuerung",
            "wordLabel": "Wechselansicht",
            "basicsTitle": "Was sind Switchviews?",
            "basicsText": "Viele Watchfaces können im selben Bereich des Bildschirms unterschiedliche Informationen anzeigen. Diese alternativen Seiten werden in den Watchface-Einstellungen oft \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Top View 1/2\", \"Bottom View 1/2\" oder ähnlich genannt.",
            "proNote": "In vielen Fällen handelt es sich dabei um Pro-Features, die während eines Testzeitraums verfügbar sind und danach nur mit Freischaltcode genutzt werden können.",
            "gestureTitle": "Ansichten mit einer Handgelenksgeste wechseln",
            "gestureIntro": "Auf Uhren ohne kompatiblen Touchscreen können die alternativen Ansichten über eine zweite Handgelenksbewegung gewechselt werden.",
            "gestureStep1": "Drehe dein Handgelenk wie gewohnt, um das Display zu aktivieren. Die eingeblendeten Sekunden bzw. der hellere Bildschirm zeigen an, dass die Uhr im aktiven Modus ist.",
            "gestureStep2": "Führe innerhalb weniger Sekunden (ca. 7 Sekunden) dieselbe Handgelenksbewegung erneut aus – nicht zu ruckartig, aber deutlich genug, damit die Uhr sie als zweite Geste erkennt.",
            "gestureStep3": "Unterstützt das Watchface Switchviews, wechseln die konfigurierten Bereiche (z.B. obere oder untere Ansicht) auf die nächste Seite.",
            "gestureHint": "Wenn sich nichts ändert, überprüfe die Watchface-Einstellungen: manche Ansichten müssen explizit zugewiesen werden (z.B. \"Top View 2\" / \"Bottom View 2\").",
            "touchTitle": "Switchviews auf Touchscreen-Geräten",
            "touchIntro": "Auf neueren Uhren mit kompatiblem Touchscreen (z.B. Fenix 7 und neuer) können Ansichten häufig auch über definierte Touchzonen gewechselt werden.",
            "touchConfig": "In vielen Watchfaces kannst du diese Zonen in den Einstellungen konfigurieren, meist weiter unten in der Liste. Typische Beispiele sind die Stunden- und Minutenziffern der Uhrzeit oder eigene Bereiche auf dem Display.",
            "touchHold": "Ist eine Touchzone konfiguriert, wechselt ein langer Druck auf die entsprechende Ziffer/Fläche die zugewiesene Ansicht.",
            "touchMultiple": "Einige Watchfaces bieten mehrere Zonen, die getrennt belegt werden können – z.B. eine Zone für die obere und eine für die untere Ansicht.",
            "touchInfo": "Falls ein Watchface spezielle Zonen besitzt, werden diese in der Regel im Infotext zum Watchface auf dieser Webseite oder im ConnectIQ Store beschrieben."
        },
        "findWfId": {
            "title": "WatchfaceID finden",
            "whatIs": "Was ist die WatchfaceID?",
            "whatIsExplanation": "Jedes Watchface hat pro Gerät eine eigene WatchfaceID. Es ist eine 5–6-stellige Zahl. Sie wird für den Kauf eines Freischaltcodes oder für den Support benötigt.",
            "connectIqTitle": "Über die ConnectIQ App (empfohlen)",
            "ciq1": "Stelle sicher, dass die Uhr per Bluetooth mit dem Telefon verbunden ist.",
            "ciq2": "Öffne die ConnectIQ App auf dem Telefon.",
            "ciq3": "Navigiere zur Watchface-Seite mit Beschreibung und Bildern. Nutze bei Bedarf die Suche oder „Meine Watchfaces“ unter „Gerät“.",
            "ciq4": "Drücke auf der Watchface-Seite auf „Einstellungen“, um alle Einstellungen zu öffnen.",
            "ciq5": "Die WatchfaceID steht im obersten Feld. Kopiere oder notiere diese Zahl – sie wird für die Zahlung benötigt.",
            "keyEntryTitle": "Freischaltcode eingeben",
            "keyEntryExplanation": "Unter dem WatchfaceID-Feld findest du das Feld für den Key/Code, der nach der Zahlung zugeschickt wird. Bei manchen Watchfaces wird dort die restliche Testzeit angezeigt – lösche das ggf. vor der Code-Eingabe.",
            "garminExpressTitle": "Über Garmin Express (Desktop)",
            "ge1": "Installiere Garmin Express und verbinde die Uhr mit dem Computer.",
            "ge2": "Gehe zur Liste der installierten Watchfaces.",
            "ge3": "Klicke auf die Drei-Punkte-Schaltfläche neben dem Watchface-Eintrag, um die Einstellungen zu öffnen.",
            "ge4": "Folge den gleichen Schritten wie bei der ConnectIQ App.",
            "geNote": "Hinweis: Die ConnectIQ App ist empfohlen, da manche Garmin-Express-Versionen Fehler verursachen können.",
            "zeroId": "WatchfaceID zeigt 0?",
            "zeroIdExplanation": "Manchmal wird die WatchfaceID als 0 angezeigt. Oft hilft einmaliges Speichern der Einstellungen oder ein Neustart der Uhr. Zeigt sie danach weiterhin 0, funktioniert die Zahlung in der Regel trotzdem."
        },
        "location": {
            "title": "GPS & Standort einrichten",
            "whatIsGpsFix": "Was ist ein GPS-Fix?",
            "gpsFixExplanation": "Ein GPS-Fix teilt dem Watchface deinen Standort mit, damit Sonnenauf-/untergang, Mondphasen, Wetterstandort und Gezeiten korrekt berechnet werden.",
            "howTo": "GPS-Fix durchführen",
            "step1": "Navigiere auf der Uhr zum Startbildschirm einer Aktivität (z. B. „Laufen“).",
            "step2": "Warte, bis die Uhr ein GPS-Signal hat (grüner Balken/Icon).",
            "step3": "Kehre zum Watchface zurück – die Daten sollten sich binnen weniger Minuten aktualisieren.",
            "alternative": "Alternative: Handy-GPS",
            "alternativeExplanation": "Du kannst auch GPS am Telefon aktivieren. Die Uhr muss per Bluetooth verbunden sein. Diese Methode ist langsamer, funktioniert aber ebenso.",
            "requirements": "Voraussetzungen",
            "req1": "Uhr per Bluetooth mit dem Telefon verbunden",
            "req2": "Garmin Connect App (nicht ConnectIQ) mindestens im Hintergrund aktiv",
            "req3": "GPS auf dem Telefon aktiv (für standortbasierte Nutzung)"
        },
        "settings": {
            "tabs": {
                "options": "Datenfeldoptionen",
                "change": "Einstellungen ändern",
                "troubleshoot": "Fehlerbehebung"
            },
            "title": "Watchface-Einstellungen",
            "optionsIntro": "Hier ist die allgemeine Liste mit allen Optionen für Datenfelder. Klicke darauf, um eine Beschreibung zu erhalten. Beachte, dass nicht alle Optionen für alle Watchfaces verfügbar sind oder sich im Namen leicht unterscheiden.",
            "change": {
                "title": "Einstellungen ändern",
                "intro": "Die Einstellungen zu den Watchfaces kannst du über die ConnectIQ-App auf dem Telefon ändern.",
                "step1": "Verbinde deine Uhr per Bluetooth mit dem Telefon und öffne die ConnectIQ-App (nicht die Connect-App).",
                "step2": "Navigiere zur Seite des Watchfaces. Ist es noch nicht installiert, installiere es zuerst.",
                "step3": "Auf der Seite des Watchfaces findest du einen Button „Einstellungen“ – tippe darauf, dann öffnet sich die Liste mit allen Watchface-Einstellungen.",
                "step4": "Dort sind sämtliche Datenfelder, Farben und erweiterte Optionen veränderbar.",
                "step5": "Rechts oben befindet sich der Button zum Speichern – dieser überträgt die Einstellungen auf die Uhr, die Liste wird danach geschlossen.",
                "installLink": "Installationsanleitung"
            },
            "troubleshoot": {
                "title": "Fehlerbehebung",
                "cantSave": {
                    "q": "Einstellungen lassen sich nicht speichern – Fehlermeldung erscheint",
                    "a1": "Manchmal haben die Garmin-Server Probleme mit bestimmten Zeichen.",
                    "a2": "Leere das Feld für das Farbschema (falls vorhanden) in den Einstellungen und versuche danach erneut zu speichern – das sollte funktionieren."
                },
                "wontOpen": {
                    "q": "Die Einstellungen öffnen sich nicht",
                    "a1": "ConnectIQ-App vollständig schließen und die Uhr ggf. neu starten.",
                    "a2": "Wenn nur ein Button „Installation“ angezeigt wird, ist das Watchface noch nicht auf der Uhr installiert."
                },
                "missingOptions": {
                    "q": "Ich finde bestimmte Einstellungsoptionen nicht",
                    "a": "Nicht alle Optionen sind auf allen Geräten verfügbar. Das Angebot hängt von deinem Uhrenmodell und dem jeweiligen Watchface ab."
                },
                "naValue": {
                    "q": "Ein Datenfeld zeigt nur „n/a“",
                    "a": "Dein Gerät unterstützt diese Option nicht – meist weil es ein älteres Modell ist oder die nötige Hardware (z. B. Barometer, Pulsoximeter) fehlt."
                }
            }
        },
        "dateFormat": {
            "title": "Benutzerdefiniertes Datumsformat (Datum 1 / 2 / 3)",
            "basicsTitle": "Was sind die Datumsformat-Felder?",
            "basicsIntro": "In den Watchface-Einstellungen gibt es zwei Felder (oder drei, falls das Watchface es unterstützt), mit denen du festlegst, wie Datum 1, Datum 2 und ggf. Datum 3 angezeigt werden. Je nachdem, welche Buchstaben du in das jeweilige Feld eingibst, wird die entsprechende Option so gerendert.",
            "notAll": "Das ist nicht auf allen Watchfaces verfügbar.",
            "where": "Die Felder zum Konfigurieren des Datumsformats befinden sich meist weiter unten in den Watchface-Einstellungen, unterhalb der Datenfeldoptionen.",
            "codesTitle": "Formatcodes",
            "codesIntro": "Im Formatfeld kannst du folgende Buchstaben verwenden. Die Anzeige entspricht dem aktuellen Datum.",
            "codeD": "Tag des Monats (mit führender Null)",
            "codeDText": "Tag als Text (z. B. Montag)",
            "codeM": "Monat numerisch (mit führender Null)",
            "codeMText": "Monat als Text",
            "codeY": "Jahr zweistellig",
            "codeY4": "Jahr vierstellig",
            "codeJ": "Julianisches Datum (Militär)",
            "codeW": "Wochennummer",
            "codeO": "Monat ohne führende Null",
            "codeN": "Tag ohne führende Null",
            "codeP": "Tag des Jahres",
            "exampleHint": "Beispiel: „D, d.M.Y“ könnte „Mo, 27.02.2026“ anzeigen."
        }
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Abonniere den Newsletter für Updates zu neuen Watchfaces, Features und Aktionen.",
        "frequencyHint": "Geschätzt eine E-Mail alle 2 Monate – Abmeldung jederzeit möglich.",
        "emailPlaceholder": "Deine E-Mail-Adresse",
        "subscribe": "Abonnieren",
        "unsubscribe": "Abmelden",
        "subscribeSuccess": "Erfolgreich abonniert! Bitte überprüfe deine E-Mails.",
        "subscribeError": "Ein Fehler ist aufgetreten. Bitte versuche es später erneut.",
        "unsubscribeSuccess": "Erfolgreich abgemeldet.",
        "unsubscribeError": "Ein Fehler ist aufgetreten. Bitte versuche es später erneut."
    },
    "contact": {
        "title": "Kontakt",
        "description": "Hast du eine Frage oder benötigst Unterstützung? Sende mir eine Nachricht.",
        "emailLabel": "E-Mail",
        "emailPlaceholder": "deine@email.de",
        "deviceLabel": "Gerät (optional)",
        "devicePlaceholder": "z.B. Fenix 7",
        "watchfaceLabel": "Watchface (optional)",
        "watchfacePlaceholder": "z.B. Horizon",
        "messageLabel": "Nachricht",
        "messagePlaceholder": "Deine Nachricht...",
        "send": "Nachricht senden",
        "sendAnother": "Weitere Nachricht senden",
        "successTitle": "Nachricht gesendet!",
        "successMessage": "Ich melde mich so schnell wie möglich.",
        "error": "Ein Fehler ist aufgetreten. Bitte versuche es erneut oder schreibe direkt an dev@orcatec.net.",
        "rateLimit": "Maximal 2 Nachrichten alle 5 Minuten. Bitte versuche es später erneut.",
        "consentNotice": "Mit dem Absenden stimmst du der Verarbeitung deiner Daten gemäß unserer",
        "guidesIntro": "Wenn du Fragen zu bestimmten Funktionen hast, helfen dir vielleicht schon diese Anleitungen weiter:",
        "faqIntro": "Zu vielen Themen gibt es außerdem ausführliche FAQ:",
        "faqLinkLabel": "Hilfe & Anleitungen öffnen",
        "responseTimeNotice": "Bitte hab Verständnis dafür, dass die Antwortzeit zu Stoßzeiten auch gerne einmal mehrere Tage in Anspruch nehmen kann."
    },
    "refund": {
        "title": "Erstattungsrichtlinie"
    },
    "terms": {
        "title": "Nutzungsbedingungen"
    },
    "privacy": {
        "title": "Datenschutzhinweise"
    },
    "footer": {
        "description": "Moderne Garmin Apps mit erweiterten Funktionen für alle Aktivitäten.",
        "tagline": "Moderne Garmin Apps mit erweiterten Funktionen für alle Aktivitäten.",
        "linksTitle": "Links",
        "socialsTitle": "Socials",
        "terms": "Nutzungsbedingungen",
        "impressum": "Impressum",
        "privacy": "Datenschutz",
        "refund": "Erstattungsrichtlinie",
        "contact": "Kontakt",
        "rights": "Alle Rechte vorbehalten.",
        "links": "Links",
        "contactDescription": "Fragen oder Support?",
        "contactLink": "Kontakt aufnehmen",
        "copyright": "Orcatec - TitanicTurtle. Alle Rechte vorbehalten.",
        "garminForums": "Garmin Forums"
    },
    "tides": {
        "title": "Gezeiten via Stormglass.io",
        "intro": "Wenn Sie die Gezeitenfunktion auf einem Watchface verwenden möchten, das Stormglass als Anbieter nutzt, müssen Sie sich auf deren Website registrieren, um einen API-Schlüssel zu erhalten, den Sie in das entsprechende Feld in Ihren Watchface-Einstellungen eingeben können.",
        "apiKey": {
            "title": "API-Schlüssel kopieren",
            "description": "Wenn Sie Ihren API-Schlüssel von überall kopieren, stellen Sie sicher, dass alle Zeichen enthalten sind (normalerweise über 60) - manchmal schneidet Android/IOS einen Teil nach einem \"-\" ab."
        },
        "freePlan": {
            "title": "Kostenloser Plan",
            "description": "Der kostenlose (stormglass io) Plan bietet 10 kostenlose Anfragen pro Tag, was ausreicht, um Gezeitendaten für unterstützte TitanicTurtle Watchfaces bereitzustellen.",
            "note": "(Wenn Ihr Watchface Stormglass io als Wetteranbieter unterstützt und Sie es verwenden möchten, benötigen Sie möglicherweise einen anderen Abonnementplan)"
        },
        "dataDownload": {
            "title": "Daten-Download",
            "description": "Normalerweise werden Gezeitendaten für mehrere Tage heruntergeladen und täglich aktualisiert, wenn eine Telefonverbindung verfügbar ist. Selbst wenn Sie keine Internetverbindung haben, sollten die Gezeitendaten mindestens für 3 (Horizon) / 5 (Centurion) Tage angezeigt werden. (hängt vom Watchface / Gerät ab)"
        },
        "initialSetup": {
            "title": "Ersteinrichtung",
            "description": "Sobald Sie den Stormglass io API-Schlüssel in den Einstellungen eingegeben haben, kann es bis zu 30 Minuten dauern, bis die Daten heruntergeladen und verfügbar sind."
        },
        "locationUpdate": {
            "title": "Standortaktualisierung",
            "description": "Wenn Sie Ihre Position ändern, stellen Sie sicher, dass Sie ein GPS-Signal auf Ihrer Uhr erhalten, damit die Gezeitendaten für den neuen Standort aktualisiert werden können."
        },
        "requirements": {
            "title": "Voraussetzungen",
            "bluetooth": "Stellen Sie sicher, dass Ihre Uhr über Bluetooth mit Ihrem Telefon verbunden ist, auf dem die Connect App (nicht Connect IQ) mindestens im Hintergrund läuft.",
            "gps": {
                "title": "GPS-Fix",
                "description": "Wenn Sie eine Meldung wie \"GPS?\" auf Ihrer Uhr sehen, führen Sie einen GPS-Fix durch, damit das Watchface Ihre Position kennt.",
                "steps": {
                    "step1": "Gehen Sie auf der Uhr in den Startbildschirm einer Aktivität wie \"Laufen\"",
                    "step2": "Warten Sie, bis die Uhr ein GPS-Signal erhalten hat"
                }
            }
        }
    },
    "common": {
        "loading": "Wird geladen...",
        "error": "Fehler",
        "retry": "Erneut versuchen",
        "back": "Zurück",
        "close": "Schließen",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "confirm": "Bestätigen",
        "notFound": "404 – Seite nicht gefunden"
    },
    "watchfacesOverview": {
        "title": "Alle Apps",
        "loading": "Apps werden geladen...",
        "error": "Fehler beim Laden der Apps",
        "retry": "Erneut versuchen",
        "noWatchfaces": "Keine Apps verfügbar"
    },
    "detailTabs": {
        "payment": "Zahlung",
        "themes": "Themes",
        "info": "Info",
        "instructions": "Anleitungen",
        "instructionsIntro": "Alle Anleitungen auf einen Blick:",
        "noThemes": "Keine Farbthemes für dieses Watchface verfügbar."
    },
    "watchfaceDetail": {
        "loading": "Watchface wird geladen...",
        "error": {
            "notFound": "Watchface nicht gefunden",
            "loading": "Fehler beim Laden des Watchfaces"
        },
        "backToOverview": "Zurück zur Übersicht",
        "goToStore": "Zum IQ Store",
        "goToTrial": "Kostenlos testen (VX)",
        "devices": "Geräte",
        "info": {
            "title": "Features",
            "tides": "🌊 Gezeiten-Informationen mit automatischen Updates",
            "weather": "🌤️ Wetterdaten von OpenWeatherMap und Yr",
            "colors": "🎨 Farbthemes und Anpassungen",
            "location": "📍 GPS-basierte Standortbestimmung",
            "faq": "❓ FAQ und Support",
            "weatherFallback": "Wenn ein OpenWeatherMap Api-Schlüssel ohne Once Call 3.0 Abonnement eingegeben wird, gibt es einen Fallback auf den \"Yr\" Wetterdatenanbieter."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Wie funktionieren Themes?:",
            "description": "Oben in deinen Watchface-Einstellungen hast du einen \"Themestring\", der deine aktuellen Farbeinstellungen (für Icons, Diagramm, Zeit etc.) deines Watchfaces darstellt. Wenn du etwas änderst (z.B. die Farbe des oberen Bereichs) und \"Speichern\" drückst, aktualisiert sich der Themestring beim nächsten Öffnen der Einstellungen. Auf diese Weise kannst du deine Farbeinstellungen speichern, indem du den Themestring kopierst und woanders speicherst. Du kannst ihn sogar mit anderen teilen, z.B. in den Bewertungen / im Forum, und du kannst die Themestrings anderer Leute anwenden, um andere Stile auszuprobieren."
        },
        "dynamicThemeSwitching": {
            "title": "Dynamisches Theme-Switching:",
            "sunset": {
                "title": "Nach Sonnenuntergang / Vor Sonnenaufgang wechseln -",
                "description": "Wenn du ein Ausrufezeichen ! vor den Themestring setzt, zu dem du wechseln möchtest, wird er als das Theme gespeichert, zu dem nach Sonnenuntergang gewechselt wird (Beispiel: !UEUE[UEUEEEEEEU^). Du kannst es jederzeit ändern, indem du einen Themestring mit einem führenden Ausrufezeichen ! in das Themestring-Feld eingibst. Wenn du den Themestring für die Nachtzeit löschen möchtest, gib einfach ein einzelnes Ausrufezeichen ! in das Themestring-Feld ein und es wird nicht mehr gewechselt."
            },
            "lowPower": {
                "title": "Im Energiesparmodus wechseln -",
                "description": "Es ist derselbe Prozess wie beim Festlegen eines Themes für Sonnenuntergang/Sonnenaufgang oben, aber anstelle von ! setze ein # vor deinen Themestring (Beispiel: #UEUE[UEUEEEEEEU^). Jede Uhr tritt nach ~10 Sekunden in einen \"Energiesparmodus\" ein, wenn du auf die Uhr schaust / aus einem Menü zurückkommst. Normalerweise verschwinden die Sekunden im Energiesparmodus standardmäßig (kann in den Watchface-Einstellungen geändert werden). Beide Wechseloptionen (@night/@LowPower) können kombiniert werden. Einmal gesetzt ist ein dynamischer Themestring in deinen Watchface-Einstellungen nicht sichtbar, also stelle sicher, dass du ihn woanders speicherst, falls du in Zukunft Änderungen vornehmen möchtest."
            }
        }
    },
    "colorThemes": {
        "clickToCopy": "Klicken zum Kopieren",
        "clickToPreview": "Klicken für Vorschau",
        "closePreview": "Vorschau schließen",
        "copied": "Kopiert!",
        "useInSettings": "Verwende es in deinen Watchface-Einstellungen",
        "guideLink": "Mehr Informationen zu Themes & Themestrings",
        "deviceNote": "Hinweis: Farbthemes sind nicht auf allen Geräten verfügbar.",
        "noFieldNote": "Haben deine Watchface-Einstellungen kein separates Feld für die Farbschemas, so werden diese auf diesem Watchface nicht für dein Uhrenmodell unterstützt."
    },
    "payment": {
        "option1": {
            "title": "Zahlungsoption 1: Garmin Pay",
            "description": "Kaufe das bezahlte Watchface direkt über Garmin Pay im ConnectIQ Store (wenn deine Uhr unterstützt wird).",
            "link": "Link zum ConnectIQ Store"
        },
        "option2": {
            "title": "Zahlungsoption 2: Direkte Zahlung über WatchfaceID",
            "description": "Wenn deine Uhr nicht von der bezahlten Pro-Version unterstützt wird, kannst du einen Trial/VX-Versionsschlüssel direkt kaufen, indem du deine WatchfaceID eingibst.",
            "vxNote": "Dies ist ein Schlüssel für die VX-Version des Watchfaces, nicht die Garmin Pay-Version!",
            "vxLink": "Link zur VX-Version"
        },
        "tax": "MwSt.",
        "wfid": {
            "description": "Gib deine WatchfaceID ein (findest du in deinen Watchface-Einstellungen)",
            "placeholder": "WatchfaceID eingeben (5-6 Ziffern)",
            "guideLink": "Wie finde ich meine WatchfaceID?",
            "guideLinkShort": "Anleitung anzeigen"
        },
        "wfidError": {
            "letters": "WatchfaceID sollte nur Zahlen enthalten",
            "tooLong": "WatchfaceID sollte 5-6 Ziffern lang sein",
            "invalid": "Bitte gib eine gültige WatchfaceID ein (5-6 Ziffern)",
            "lengthHint": "Eine WatchfaceID besteht in der Regel aus 5–6 Ziffern. Bitte prüfe die Eingabe."
        },
        "errors": {
            "empty": "Bitte gib deine WatchfaceID ein",
            "invalid": "Bitte gib eine gültige WatchfaceID ein",
            "config": "Zahlungskonfigurationsfehler",
            "checkout": "Checkout konnte nicht geöffnet werden. Bitte versuche es erneut."
        },
        "buy": "Jetzt kaufen",
        "selectMethod": "Version wählen",
        "versionSelectHint": "Dies sind zwei separate Versionen — bitte wähle die richtige aus:",
        "vxWarning": "Die VX und Elite Version sind jeweils eigenständig herunterladbare Versionen des Ziffernblattes. Ein Aktivierungscode für die VX Version schaltet NICHT die Elite Version frei.",
        "beta": {
            "title": "Derzeit in der Betaphase",
            "description": "Während dieser Zeit kann das Watchface komplett kostenlos verwendet werden. Auch nach der Testphase fallen keine automatischen Kosten an. In dieser Phase werden neue Features und Funktionen getestet. Danke für euer Feedback!",
            "descriptionApp": "Während dieser Zeit kann die App komplett kostenlos verwendet werden. Auch nach der Testphase fallen keine automatischen Kosten an. In dieser Phase werden neue Features und Funktionen getestet. Danke für euer Feedback!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite Version",
            "description": "Dieses Watchface ist ausschließlich über Garmin Pay im ConnectIQ Store erhältlich.",
            "comboDescription": "Direkt über Garmin Pay im ConnectIQ Store kaufen. Dies ist eine separate, eigenständige Version.",
            "compatibility": "Hinweis: Nicht alle Uhrenmodelle unterstützen Garmin Pay. Prüfe die Kompatibilität deines Geräts auf der Store-Seite. Ansonsten VX Version laden (technisch identisch).",
            "storeLink": "Im ConnectIQ Store öffnen",
            "moreGuide": "Mehr Details zum Unterschied zwischen Elite- und VX-Version?",
            "moreGuideLink": "Kauf- & Installationsanleitung lesen",
            "eliteNoKey": "Beim Kauf einer Elite-Version über Garmin Pay wird kein Freischaltcode zugeschickt. Die Elite-Version ist direkt nach dem Kauf freigeschaltet und benötigt keinen Code.",
            "accountBound": "Der Kauf über Garmin Pay ist an deinen Garmin Account gebunden und direkt für deine zukünftigen Geräte freigeschaltet (falls kompatibel).",
            "eliteNoKeyAndGuide": "Beim Kauf über Garmin Pay wird kein Freischaltcode verschickt — die Elite Version ist direkt nach dem Kauf freigeschaltet. Mehr Details findest du in der Kauf- & Installationsanleitung."
        },
        "vx": {
            "badge": "Alle Geräte",
            "title": "VX Version",
            "description": "Kompatibel mit allen unterstützten Geräten. Lade die kostenlose Testversion aus dem ConnectIQ Store herunter und aktiviere sie hier mit einem gekauften Code.",
            "trialNote": "Die VX Version enthält eine kostenlose Testphase. Nach der Testphase kannst du unten einen Aktivierungscode kaufen, um sie dauerhaft freizuschalten.",
            "deviceBound": "Ein Freischaltcode ist an dein Gerät gebunden und schaltet die VX Version dauerhaft frei.",
            "moreGuide": "Mehr Infos zur VX-Version, zu Schlüsseln oder zur Installation?",
            "moreGuideLink": "Kauf- & Installationsanleitung lesen",
            "downloadLink": "VX Version herunterladen",
            "details": {
                "line1": "Nach erfolgreicher Zahlung wird der Aktivierungsschlüssel an die E-Mail-Adresse geschickt, die du im nächsten Schritt eingibst.",
                "line2": "Bitte achte darauf, dass die E-Mail-Adresse korrekt ist.",
                "line3": "Bitte prüfe nach einer erfolgreichen Zahlung deinen Spam-Ordner – Key-E-Mails landen dort häufig.",
                "line4": "Alle Zahlungsoptionen werden über Paddle abgewickelt – kein Konto erforderlich.",
                "line5": "Für Supportanfragen verwende bitte das Kontaktformular oder das ConnectIQ Store Tool.",
                "line6": "Andere Anfragen können nicht bearbeitet werden."
            }
        },
        "standalone": {
            "title": "Aktivierungscode kaufen",
            "description": "Kaufe einen Aktivierungscode, indem du unten deine WatchfaceID eingibst. Der Code wird dir sofort zugesendet."
        },
        "checkoutOpening": "Checkout wird geöffnet...",
        "info": {
            "key": "Nach dem Kauf erhältst du einen Schlüssel, den du in deinen Watchface-Einstellungen eingeben kannst.",
            "activation": "Der Schlüssel wird sofort nach erfolgreicher Zahlung aktiviert.",
            "support": "Wenn du Fragen hast, kontaktiere bitte den Support.",
            "moreGuide": "Mehr Details zu Kauf & Installation"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Kreditkarte"
        }
    },
    "fonts": {
        "title": "Schriftarten",
        "timefonts": "Zeitschriften",
        "datafonts": "Daten-Schriften"
    },
    "weather": {
        "title": "Wetterdatenanbieter",
        "intro": "Für viele Watchfaces gibt es auf den meisten Geräten eine Auswahl an verschiedenen Wetterdatenanbietern. Der Wetterdatenanbieter kann in den Einstellungen zum jeweiligen Watchface in der ConnectIQ App geändert werden. Standardmäßig ist in den meisten Fällen Garmin-Wetter oder Yr als Wetterdatenanbieter ausgewählt.",
        "noData": "Zeigt ein Wetter-Datenfeld 'no data' an so konnten keine Wetterdaten geladen werden. Unten finden sich die jeweiligen Schritte um Wetterdaten auf die Uhr zu bekommen.",
        "tabs": {
            "garmin": "Garmin",
            "yr": "Yr",
            "openweathermap": "OpenWeatherMap",
            "visualcrossing": "Visual Crossing",
            "location": "Location"
        },
        "garmin": {
            "title": "Verwendung von Garmin Wetter:",
            "description": "Wenn das Gerät Garmin-Wetter unterstützt, müssen Sie nur die Garmin Uhr über Bluetooth mit einem Telefon verbinden und sicherstellen, dass die Connect App (nicht Connect IQ) zumindest im Hintergrund läuft und Zugriff auf den aktuellen Standort Ihres Telefons hat. (Der aktuelle Standort (GPS) muss eingeschaltet sein)",
            "download": "Die Uhr lädt dann automatisch die Wetterdaten von diesem Dienst herunter, was ein paar Minuten dauern kann.",
            "check": "Man kann außerdem kontrollieren ob das interne Garmin Wetter Widget auf der Uhr bereits Wetterdaten anzeigt. Sind dort keine Daten zu sehen kann auch das Watchface nichts anzeigen da es sich um dieselbe Datenquelle handelt.",
            "noApiKey": "Für Garmin Wetter ist kein extra API-Schlüssel notwendig.",
            "location": "Bei einigen Watchfaces wird bei der Verwendung von Garmin Wetter außerdem der jeweilige mitgelieferte Standort angezeigt. Bei Garmin Wetterstationen handelt es sich meist um den nächstgelegenen Flugplatz - eine genauere Angabe des Ortes ist nur mit anderen Wetterdatenanbietern möglich.",
            "update": "Der Standort wird zeitnah aktualisiert sobald die Standortdaten auf dem Telefon aktiv sind.",
            "noData": "Falls keine Wetterdaten angezeigt oder aktualisiert werden können wird die Meldung 'no data' angezeigt -> obige Schritte durchführen.",
            "missingData": {
                "title": "Daten die nicht in Garmin Wetter enthalten sind:",
                "airQuality": "Luftqualität",
                "uvIndex": "UV-Index",
                "description": "Wetterbeschreibung"
            }
        },
        "yr": {
            "title": "Verwendung von Yr:",
            "description": "Yr ist ein Dienst des Norwegischen Meteorologischen Instituts und NRK und kann ohne einen API Key verwendet werden.",
            "setup": "Um Wetterdaten von Yr zu beziehen, dieses als Wetterdatenanbieter auswählen und die Uhr mit dem Telefon per Bluetooth verbinden.",
            "connectApp": "Auf dem Telefon darauf achten, dass die Connect App (nicht ConnectIQ) zumindest im Hintergrund läuft - die Uhr lädt darüber unter anderem Wetterdaten aus dem Internet.",
            "interval": "Falls das Watchface über eine Funktion zur Einstellung des Updateintervals verfügt, so ist bei Yr als Wetterdatenanbieter ein Minimum an 10 Minuten möglich.",
            "noData": {
                "title": "no data / falscher Standort:",
                "description": "Falls keine Wetterdaten geladen werden oder der angezeigt Standort falsch ist so kann dies leicht behoben werden indem der abgespeicherte Standort des Watchfaces aktualisiert wird.",
                "fix": "Dazu auf der Uhr in den Startbildschirm einer Aktivität wie 'Laufen' gehen und warten bis die Uhr ein GPS Signal hat. Die Wetterdaten / der Standort sollte sich dann innerhalb von Minuten aktualisieren."
            },
            "missingData": {
                "title": "Daten die nicht in Yr enthalten sind:",
                "airQuality": "Luftqualität"
            }
        },
        "openweathermap": {
            "title": "Verwendung von OpenWeatherMap:",
            "description": "Wenn Ihr Watchface OpenWeatherMap als Wetterdatenanbieter unterstützt und Sie es verwenden möchten, benötigen Sie einen kostenlosen API-Schlüssel, den Sie auf deren Website erhalten können:",
            "setup": "Sobald Sie den Schlüssel erhalten haben, können Sie ihn in das entsprechende Feld in Ihren Watchface-Einstellungen eingeben. (Es kann einige Stunden dauern, bis ein neu generierter Schlüssel tatsächlich funktioniert)",
            "connect": "Stellen Sie sicher, dass die Uhr über Bluetooth mit Ihrem Telefon verbunden ist und die Connect App (nicht Connect IQ) mindestens im Hintergrund läuft, damit Wetterdaten heruntergeladen werden können.",
            "gps": "Wenn Sie eine Meldung wie \"GPS?\" auf Ihrer Uhr sehen, führen Sie einen GPS-Fix durch, damit das Watchface Ihre Position kennt. (Gehen Sie in den Startbildschirm einer Aktivität wie \"Laufen\" und warten Sie, bis die Uhr ein GPS-Signal erhalten hat)",
            "uv": {
                "title": "UV-Index / Niederschlag bei OpenWeatherMap:",
                "oldKey": "Wenn Sie einen älteren API-Schlüssel haben (vor ~Feb23 generiert), können Sie diese Metriken ohne Probleme verwenden.",
                "newKey": "Wenn Sie Ihren API-Schlüssel nach diesem Datum generiert haben und diese von OpenWeatherMap bereitgestellten Metriken sehen möchten, benötigen Sie möglicherweise ein zusätzliches (kostenloses) Abonnement, nämlich den \"One Call by Call\"-Abonnementplan.",
                "limit": "Die ersten 1000 Anfragen pro Tag basierend auf diesem Abonnement sind im Grunde kostenlos und Sie können das Limit auf 1000 Anfragen setzen, was mehr als genug ist, um den ganzen Tag über Wetterdaten für jedes meiner Watchfaces bereitzustellen."
            },
            "select": "Wenn das Watchface mehr als einen Drittanbieter-Wetteranbieter unterstützt, stellen Sie sicher, dass OpenWeatherMap als aktueller Wetteranbieter im Dropdown-Menü in Ihren Watchface-Einstellungen ausgewählt ist."
        },
        "visualcrossing": {
            "title": "Verwendung von Visual Crossing:",
            "description": "Wenn Sie Visual Crossing verwenden möchten, müssen Sie auf deren Website gehen und einen kostenlosen API-Schlüssel erhalten.",
            "setup": "Sobald Sie Ihren Schlüssel erhalten haben, können Sie ihn in das entsprechende Feld in Ihren Watchface-Einstellungen eingeben und Visual Crossing als Ihren Wetterdatenanbieter im Dropdown-Menü auswählen.",
            "connect": "Stellen Sie sicher, dass die Uhr über Bluetooth mit Ihrem Telefon verbunden ist und die Connect App (nicht Connect IQ) mindestens im Hintergrund läuft, damit Wetterdaten heruntergeladen werden können.",
            "gps": "Wenn Sie eine Meldung wie \"GPS?\" auf Ihrer Uhr sehen, führen Sie einen GPS-Fix durch, damit das Watchface Ihre Position kennt. (Gehen Sie in den Startbildschirm einer Aktivität wie \"Laufen\" und warten Sie, bis die Uhr ein GPS-Signal erhalten hat)"
        },
        "location": {
            "title": "Standortaktualisierung",
            "description": "Um Wetterdaten korrekt anzuzeigen, benötigt das Watchface Ihren aktuellen Standort. Dieser wird über GPS ermittelt.",
            "gpsFix": {
                "title": "GPS-Fix durchführen:",
                "description": "Wenn Sie eine Meldung wie \"GPS?\" auf Ihrer Uhr sehen, müssen Sie einen GPS-Fix durchführen, damit das Watchface Ihre Position kennt.",
                "step1": "Gehen Sie auf der Uhr in den Startbildschirm einer Aktivität wie \"Laufen\"",
                "step2": "Warten Sie, bis die Uhr ein GPS-Signal erhalten hat",
                "step3": "Kehren Sie zum Watchface zurück - die Wetterdaten sollten sich innerhalb von Minuten aktualisieren"
            },
            "requirements": {
                "title": "Voraussetzungen:",
                "bluetooth": "Die Uhr muss über Bluetooth mit dem Telefon verbunden sein",
                "connectApp": "Die Connect App (nicht Connect IQ) muss mindestens im Hintergrund laufen",
                "gps": "GPS muss auf dem Telefon aktiviert sein"
            }
        }
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Die Bierwandern-App – tracke deine Wanderung und deine Umtrünke, die du auf dem Weg genießt. Oben drauf gibt's noch eine Promilleschätzung mit Chart (ungefähre Schätzung), aber bitte nicht für voll nehmen!",
        "settingsHint": "Drücke im Startbildschirm den Menü-Knopf auf deiner Uhr, um ins Einstellungsmenü zu gelangen (auf Uhren mit 2-Tasten-Layout lange auf den Touchscreen drücken).",
        "disclaimer": "Die Promillerechnung ist eine reine Spaß-Metrik – ein Algorithmus, der anhand konsumierter Getränke und Körpergewicht den Alkoholwert im Blut schätzt! Triff keine Entscheidungen aufgrund dieses Wertes – er ist nicht belastbar und keine richtige Messung des Alkoholwerts!",
        "closing": "Ansonsten wünsch ich dir allzeit gute Wanderungen und eine gute Zeit!",
        "support": "Bei Problemen oder Verbesserungsvorschlägen den „App Support“-Button verwenden – danke."
    },
    "bodysurf": {
        "intro": {
            "title": "Was ist BodySurf?",
            "text": "BodySurf ist eine Garmin Connect IQ Uhr-App für Bodysurfing. Sie nutzt GPS, um Wellenritte zu erkennen, misst Distanz und Dauer jedes Ritts und vergibt einen lustigen Titel je nach Strecke. Sitzungen werden als Aktivitäten mit einzelnen Laps in Garmin Connect gespeichert."
        },
        "gps": {
            "title": "Vor dem Start – GPS",
            "text1": "Warte auf einen GPS-Fix, bevor du eine Sitzung startest. Am Startbildschirm erscheint „GPS wird gesucht“, bis ein Signal verfügbar ist, danach „START um zu beginnen“.",
            "text2": "Für beste Genauigkeit nutzt die App Multi-GNSS- / Dual-Band-GPS, wenn deine Uhr es unterstützt. Stehe kurz still am Wasser, wenn der Fix länger dauert."
        },
        "start": {
            "title": "Startbildschirm",
            "startBtn": "Neue Sitzung starten, sobald GPS bereit ist (START = Sitzung beginnen).",
            "menuBtn": "Einstellungen öffnen: Wie man es benutzt und Einheiten (MENÜ = Einstellungen / Info).",
            "backBtn": "BACK = App beenden"
        },
        "during": {
            "title": "Während der Aktivität",
            "detect": "Ritte werden durch GPS erkannt Geschwindigkeit automatisch. Verwende BACK um einen Ritt manuell zu starten/stoppen. Kurze Bewegungen unter etwa 2 Metern werden verworfen.",
            "startBtn": "START = stoppen / speichern / fortsetzen",
            "backBtn": "BACK = manuelles Reiten ein/ausschalten",
            "live": "Während des Reitens siehst du die aktuelle Distanz, einen Live-Titel und „REITEN!“. Nach einem Ritt bleiben Titel und Werte sichtbar, bis der nächste Ritt beginnt."
        },
        "stop": {
            "title": "Stopp-Menü",
            "resume": "Fortsetzen",
            "save": "Speichern",
            "discard": "Verwerfen"
        },
        "after": {
            "title": "Nach der Sitzung",
            "summary": "Die Zusammenfassung zeigt Sitzungszeit, Anzahl Ritte, Gesamtdistanz und deinen Beste-Ritt mit Titel und Werten.",
            "rides": "Wischen, um Rittdetails zu sehen. Auf Tasten-Uhren: << UNTEN Rides.",
            "finished": "Danach: Neue Sitzung mit START oder App beenden mit BACK."
        },
        "titles": {
            "title": "Ritt-Titel",
            "intro": "Jeder Ritt erhält einen lustigen Titel basierend auf der Distanz. Je länger der Ritt, desto besser der Titel!",
            "colDistance": "Distanz",
            "colTitle": "Titel",
            "th0": "Strandgut",
            "th1": "Seegurke",
            "th2": "Flunder",
            "th3": "Möwenschreck",
            "th4": "Küstensheriff",
            "th5": "Brandungsbeauftragter",
            "th6": "Wellenreiter",
            "th7": "Strömungsberater",
            "th8": "Wellenbrecher",
            "th9": "Aquaman",
            "th10": "Human Surfboard",
            "th11": "Küsten-Legende",
            "th12": "Poseidon"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Gespeicherte Sitzungen erscheinen in Garmin Connect mit eigenen Feldern: Ritt-Titel, Lap-Distanz (Meter), Lap-Zeit (Sekunden) sowie längster Ritt und Zeit auf Sitzungsebene. Jeder erkannte Ritt wird als Lap gespeichert."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Auf Instinct-Uhren zeigt das Sub-Display Zeit, GPS und Rittdistanz. Statt Wischen die DOWN-Taste nutzen (<< UNTEN Rides).",
            "menu": "„Menü“ steht links am Startbildschirm. Drücke START, wenn im Sub-Display GPS OK steht."
        },
        "settings": {
            "title": "Einstellungen",
            "units": "Einheiten: zwischen metrisch und imperial für Distanz und Geschwindigkeit auf der Uhr wechseln.",
            "info": "Info: Hilfe an Bord (Wie man es benutzt) zu Tasten während der Aktivität, nach der Sitzung und am Startbildschirm."
        },
        "supportBefore": "Bei Problemen oder Verbesserungsvorschlägen nutze bitte das",
        "supportLink": "Kontaktformular",
        "supportAfter": " – danke!"
    }
};
